import { render, staticRenderFns } from "./ButtonA.vue?vue&type=template&id=52ffb358&scoped=true"
import script from "./ButtonA.vue?vue&type=script&lang=js"
export * from "./ButtonA.vue?vue&type=script&lang=js"
import style0 from "./ButtonA.vue?vue&type=style&index=0&id=52ffb358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffb358",
  null
  
)

export default component.exports